import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedDetail, PdpSharedDetailProps } from './PdpSharedDetail';
import { SharedContactDealerWrapper } from '../../../contactDealer/SharedContactDealerWrapper';

// types
import { PdpSharedDetailFramingOptions_refactor_item$key as Item } from './__generated__/PdpSharedDetailFramingOptions_refactor_item.graphql';
import { PdpSharedDetailFramingOptions_refactor_user$key as User } from './__generated__/PdpSharedDetailFramingOptions_refactor_user.graphql';

const itemFragment = graphql`
    fragment PdpSharedDetailFramingOptions_refactor_item on Item {
        ...SharedContactDealerWrapper_item
    }
`;

const userFragment = graphql`
    fragment PdpSharedDetailFramingOptions_refactor_user on User {
        ...SharedContactDealerWrapper_user
        serviceId
    }
`;

export const PdpSharedDetailFramingOptions: FC<
    PdpSharedDetailProps & { item: Item; user: User | null }
> = ({ item: itemRef, user: userRef, ...props }) => {
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);

    return (
        <>
            <PdpSharedDetail {...props} />
            <SharedContactDealerWrapper
                item={item}
                user={user}
                currency={props.currency}
                launchOrigin={'framing options'}
            >
                {(onClick: () => void) => (
                    <Link onClick={onClick} dataTn="item-details-framing-options-contact-gallery">
                        <FormattedMessage
                            defaultMessage="Contact Gallery"
                            id="PdpSharedDetailFramingOptions.contactGallery"
                        />
                    </Link>
                )}
            </SharedContactDealerWrapper>
        </>
    );
};
